import { computed, type ComputedRef } from "vue";
import useStore from "../store.ts";
import { UpdateOrigin, type UpdateContextHandle } from "./UpdateContextRegistry.ts";

export { UpdateOrigin };
export type Origin = UpdateOrigin;
export type Handle = UpdateContextHandle;

/* see docs/EXTRACTED_COMMENTS.md#c197 */
class Orchestrator {
    /* see docs/EXTRACTED_COMMENTS.md#c198 */
    enqueue(origin: Origin, body: (handle: Handle) => Promise<void> | void, channel?: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            useStore().socketManager.queueUpdate(origin, async (handle) => {
                try {
                    await body(handle);
                    resolve();
                } catch (err) {
                    reject(err);
                }
            }, reject, channel); // dropped without executing (queue clear / channel.reset) → reject, never hang
        });
    }

    /* see docs/EXTRACTED_COMMENTS.md#c804 */
    dropChannelOps(channel: string, origins: ReadonlySet<Origin>): number {
        return useStore().socketManager.getUpdateQueueManager().dropChannelOps(channel, origins);
    }

    /* see docs/EXTRACTED_COMMENTS.md#c199 */
    reset(): void {
        useStore().socketManager.getUpdateQueueManager().bumpSession();
    }

    get pending(): ComputedRef<number> {
        return computed(() => useStore().socketManager.getQueueLength());
    }
}

export const orchestrator = new Orchestrator();
